import { useEffect } from 'react';
import { useAppPlatformContextOptions } from '../../../contexts/app';
import { JourneyDetails } from '../../../server';
import { selectSetJourneyId, selectSetMembers, useQuoteStore } from '../../../stores';

const useSetJourneyData = (JourneyData?: JourneyDetails) => {
	const setJourneyId = useQuoteStore(selectSetJourneyId);
	const setMembers = useQuoteStore(selectSetMembers);
	const { locale } = useAppPlatformContextOptions();

	useEffect(() => {
		if (JourneyData) {
			setJourneyId(JourneyData.encryptedJourneyId);
			setMembers(JourneyData);

			return;
		}
	}, [locale]);
};

export default useSetJourneyData;
